import { Percent } from '@uniswap/sdk-core';
import JSBI from 'jsbi';
export var ZERO_ADDRESS = '0x0000000000000000000000000000000000000000';
export var NetworkContextName = 'NETWORK';
// 30 minutes, denominated in seconds
export var DEFAULT_DEADLINE_FROM_NOW = 60 * 30;
export var L2_DEADLINE_FROM_NOW = 60 * 5;
// transaction popup dismisal amounts
export var DEFAULT_TXN_DISMISS_MS = 25000;
export var L2_TXN_DISMISS_MS = 5000;
// used for rewards deadlines
export var BIG_INT_SECONDS_IN_WEEK = JSBI.BigInt(60 * 60 * 24 * 7);
export var BIG_INT_ZERO = JSBI.BigInt(0);
// one basis JSBI.BigInt
var BIPS_BASE = JSBI.BigInt(10000);
export var ONE_BIPS = new Percent(JSBI.BigInt(1), BIPS_BASE);
// used for warning states
export var ALLOWED_PRICE_IMPACT_LOW = new Percent(JSBI.BigInt(100), BIPS_BASE); // 1%
export var ALLOWED_PRICE_IMPACT_MEDIUM = new Percent(JSBI.BigInt(300), BIPS_BASE); // 3%
export var ALLOWED_PRICE_IMPACT_HIGH = new Percent(JSBI.BigInt(500), BIPS_BASE); // 5%
// if the price slippage exceeds this number, force the user to type 'confirm' to execute
export var PRICE_IMPACT_WITHOUT_FEE_CONFIRM_MIN = new Percent(JSBI.BigInt(1000), BIPS_BASE); // 10%
// for non expert mode disable swaps above this
export var BLOCKED_PRICE_IMPACT_NON_EXPERT = new Percent(JSBI.BigInt(1500), BIPS_BASE); // 15%
export var BETTER_TRADE_LESS_HOPS_THRESHOLD = new Percent(JSBI.BigInt(50), BIPS_BASE);
export var ZERO_PERCENT = new Percent('0');
export var TWO_PERCENT = new Percent(JSBI.BigInt(200), BIPS_BASE);
export var ONE_HUNDRED_PERCENT = new Percent('1');
export var FCT_VAULT_ADDRESS = 'FCT_VAULT_ADDRESS';
